//src/components/Headre.js

import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  Activity,
  BarChart3,
  BadgeDollarSign,
  ChevronDown,
  ClipboardList,
  Gift,
  Home,
  LogOut,
  Settings,
  Sparkles,
  Ticket,
  Users,
} from "lucide-react";

import "./Header.css";

import axios from "../axiosConfig";

function Header() {
  const navigate = useNavigate();
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  

  const [pixPendentes, setPixPendentes] = useState(0);
  const [pixContasAPagar, setPixContasAPagar] = useState(0);
  const [menuMobileAberto, setMenuMobileAberto] = useState(false);

  useEffect(() => {
    if (!usuario || !["admin", "financeiro", "comercial", "logistica"].includes(usuario.tipo)) {
      return;
    }

    let alive = true;

    const carregarPix = async () => {
      try {
        const podeVerPix =
          usuario?.tipo === "admin" ||
          usuario?.permissoes?.some((p) => p.rota === "pix" && p.pode_ler);

        if (!podeVerPix) return;

        const [pendentesRes, contasRes] = await Promise.all([
          axios.get("/admin/pix/pendentes"),
          axios.get("/admin/pix/contas-a-pagar"),
        ]);

        if (!alive) return;

        setPixPendentes(Array.isArray(pendentesRes.data) ? pendentesRes.data.length : 0);
        setPixContasAPagar(Array.isArray(contasRes.data) ? contasRes.data.length : 0);
      } catch {
        if (!alive) return;
        setPixPendentes(0);
        setPixContasAPagar(0);
      }
    };

    carregarPix();

    return () => {
      alive = false;
    };
  }, [usuario?.id]);

  if (!usuario || !["admin", "financeiro", "comercial", "logistica"].includes(usuario.tipo)) {
    return null;
  }

  const totalPix = pixPendentes + pixContasAPagar;

  const handleLogout = () => {
    localStorage.removeItem("usuario");
    localStorage.removeItem("token");
    navigate("/login");
  };

return (
  <header className="adminHeader">
    <div className="adminHeader-top">
      <Link to="/dashboard" className="adminHeader-brand">
        <img src="/logo1.png" alt="Tikpag" />
        <span>Painel Administrativo</span>
      </Link>

      <div className="adminHeader-user">
        <div className="adminHeader-avatar">
          {usuario?.nome?.charAt(0)?.toUpperCase() || "A"}
        </div>

        <span className="adminHeader-greeting">
          Olá, <strong>{usuario?.nome}</strong>
        </span>

        <button
          type="button"
          onClick={handleLogout}
          className="adminHeader-logout"
        >
          <LogOut size={13} />
          Sair
        </button>
      </div>

      <button
        type="button"
        className="adminHeader-hamburger"
        onClick={() => setMenuMobileAberto((prev) => !prev)}
        aria-label="Abrir menu"
      >
        <span />
        <span />
        <span />
      </button>
    </div>

    <nav
      className={`adminHeader-nav ${
        menuMobileAberto ? "mobile-aberto" : ""
      }`}
    >
      <div className="adminHeader-navInner">

        {/* DASHBOARD */}
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `adminHeader-link ${isActive ? "ativo" : ""}`
          }
          onClick={() => setMenuMobileAberto(false)}
        >
          <Home size={14} />
          Dashboard
        </NavLink>

        {/* SISTEMA */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <Activity size={14} />
            Sistema
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/admin/monitoramento">
              Monitoramento
            </Link>

            <Link to="/logs-recaptcha">
              Logs
            </Link>

            <Link to="/admin/tikpag-diagnostico">
              Diagnóstico da API
            </Link>
          </div>
        </div>

        {/* BI TIKPAG */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <BarChart3 size={14} />
            BI Tikpag
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/admin/tikpag-bi">
              BI Imobiliárias
            </Link>
          </div>
        </div>

        {/* USUÁRIOS */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <Users size={14} />
            Usuários
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/usuarios">
              Usuários do Sistema
            </Link>

            <Link to="/clientes">
              Clientes
            </Link>

            <Link to="/empresas">
              Empresas
            </Link>

            <Link to="/empresas/nova">
              Cadastrar Empresa
            </Link>

            <Link to="/admin/grupos-empresariais">
              Grupos empresariais
            </Link>

            <Link to="/empresas/importar">
              Importar Empresas
            </Link>

            <Link to="/perfis-cliente">
              Perfis de Cliente
            </Link>

            {usuario?.tipo === "admin" && (
              <Link to="/faq-bot">
                FAQ do Bot
              </Link>
            )}
          </div>
        </div>

        {/* OPERAÇÕES */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <ClipboardList size={14} />
            Operações
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/operacoes">
              Operações
            </Link>

            <Link to="/liberar-pedido">
              Liberar Pedido
            </Link>

            <Link to="/resgates">
              Resgates
            </Link>

            <Link to="/expedicao">
              Expedição
            </Link>

            <Link to="/admin/importar-operacao">
              Importar operação Tikpag
            </Link>

            <Link to="/resgates/manuais">
              Resgates manuais
            </Link>
          </div>
        </div>

        {/* EVENTOS */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <Ticket size={14} />
            Eventos
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/admin/eventos">
              Listar Eventos
            </Link>

            <Link to="/admin/eventos/criar">
              Criar Evento
            </Link>

            <Link to="/admin/sorteios">
              Ver Sorteios
            </Link>

            <Link to="/admin/sorteios-leads">
              Leads de Sorteios
            </Link>
          </div>
        </div>

        {/* PRÊMIOS E CAMPANHAS */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <Gift size={14} />
            Prêmios e Campanhas
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/admin/banner-home">
              Banner do Cliente
            </Link>

            <Link to="/premios">
              Prêmios
            </Link>

            <Link to="/categorias-premios">
              Categorias de Prêmios
            </Link>

            <Link to="/campanhas">
              Campanhas
            </Link>

            <Link to="/admin/todas-inscricoes">
              Inscrições em Campanhas
            </Link>
          </div>
        </div>

        {/* TIKPAG EXPERIENCE */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <Sparkles size={14} />
            Tikpag Experience
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/admin/tikpag-experience">
              Dashboard Experience
            </Link>

            <Link to="/admin/tikpag-experience/campanhas">
              Campanhas
            </Link>

            <Link to="/admin/tikpag-experience/pins">
              PINs
            </Link>

            <Link to="/admin/tikpag-experience/categorias">
              Categorias
            </Link>

            <Link to="/admin/tikpag-experience/experiencias">
              Experiências
            </Link>

            <Link to="/admin/tikpag-experience/participantes">
              Participantes
            </Link>

            <Link to="/admin/tikpag-experience/apuracoes">
              Apurações mensais
            </Link>

            <Link to="/admin/tikpag-experience/escolhas">
              Escolhas dos clientes
            </Link>

            <Link to="/admin/tikpag-experience/pins-entregas">
              Entregas e PINs
            </Link>

            <Link to="/admin/tikpag-experience/relatorios">
              Relatórios
            </Link>

            <Link to="/admin/tikpag-experience/auditoria">
              Auditoria
            </Link>
          </div>
        </div>

        {/* PONTOS */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <BarChart3 size={14} />
            Pontos
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/creditar-pontos">
              Creditar Pontos
            </Link>

            <Link to="/historico-pontos">
              Histórico de Pontos
            </Link>

            <Link to="/relatorio-pontos">
              Relatório de Pontos
            </Link>
          </div>
        </div>

        {/* PIX */}
        <div className="adminHeader-dropdown adminHeader-pix">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <BadgeDollarSign size={14} />
            PIX

            {totalPix > 0 && (
              <span className="adminHeader-badge">
                {totalPix}
              </span>
            )}

            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">
            <Link to="/admin/pix">
              Painel Pix Premiado

              {pixPendentes > 0 && (
                <span className="adminHeader-badge inline">
                  {pixPendentes}
                </span>
              )}
            </Link>

            <Link to="/admin/importar-pix">
              Cadastrar Pix para Cliente
            </Link>

            <Link to="/admin/pix/contas-a-pagar">
              Contas a pagar

              {pixContasAPagar > 0 && (
                <span className="adminHeader-badge inline">
                  {pixContasAPagar}
                </span>
              )}
            </Link>
          </div>
        </div>

        <div className="adminHeader-divider" />

        {/* CONFIGURAÇÕES */}
        <div className="adminHeader-dropdown">
          <button
            type="button"
            className="adminHeader-dropBtn"
          >
            <Settings size={14} />
            Configurações
            <ChevronDown size={13} />
          </button>

          <div className="adminHeader-dropMenu">

            {usuario?.tipo === "admin" &&
              usuario?.permissoes?.some(
                (p) =>
                  p.rota === "configuracoes-valor-ponto" &&
                  p.pode_editar
              ) && (
                <Link to="/configuracoes/valor-do-ponto">
                  Valor do Ponto
                </Link>
              )}

            {usuario?.tipo === "admin" &&
              usuario?.permissoes?.some(
                (p) =>
                  p.rota === "configuracoes-frete" &&
                  p.pode_editar
              ) && (
                <Link to="/configuracoes/valor-por-km">
                  Configurações de Frete
                </Link>
              )}

          </div>
        </div>

      </div>
    </nav>

    {menuMobileAberto && (
      <div
        className="adminHeader-overlay"
        onClick={() =>
          setMenuMobileAberto(false)
        }
      />
    )}
  </header>
);
}

export default Header;
